import r from "react";
import t from "prop-types";
import s from "classnames";
import { u as i } from "./ThemeProvider--i7ESlT5.es.js";
import { T as u } from "./index-BB-Wk85r.es.js";
import './ProgressTrackerBar.css';const _ = "ProgressTrackerBar-module__container___rErEq", g = "ProgressTrackerBar-module__progressLine___l8WsA", d = "ProgressTrackerBar-module__currentProgress___6EqWj", o = {
  container: _,
  progressLine: g,
  currentProgress: d
};
function n(e) {
  const a = i(), c = e.current / e.total * 100, l = Number(e.current).toLocaleString(e.locale), m = Number(e.total).toLocaleString(e.locale);
  return /* @__PURE__ */ r.createElement("div", { className: s(o.container) }, /* @__PURE__ */ r.createElement(u.Body2, { theme: a, responsive: !0 }, `You've viewed ${l} / ${m} results`), /* @__PURE__ */ r.createElement("div", { className: s(o.progressLine) }, /* @__PURE__ */ r.createElement(
    "div",
    {
      className: s(o.currentProgress),
      style: { width: `${c}%` }
    }
  )));
}
n.propTypes = {
  /** current number of items viewed */
  current: t.number.isRequired,
  /** total number of items available to view */
  total: t.number.isRequired,
  /** the javascript language/locale code that determines how the
   * current and total will be formatted
   */
  locale: t.string
};
n.defaultProps = {
  locale: "en-GB"
};
export {
  n as P
};
